export default function NoPagePage() {
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>It looks like the page you are looking for does not exist.</p>
    </div>
  );
}